import React from "react"
import { appTools, cn } from "lib/utils"

export default function InputField({ 
  type="text",
  children, 
  className, 
  error=null,
  ...rest
}:{ 
  type?:string
  className?:string
  error?:any
  [key:string]:any 
}){

  return (
    <input 
      type={type} 
      className={cn(
        "w-full border border-solid border-slate-700 rounded-sm h-8 flex justify-start items-center bg-slate-900 outline-transparent outline outline-offset-2 text-sm text-gray-200 px-2 py-.5 placeholder:opacity-40 placeholder:italic", 
        error && "outline-red-700",
        rest.readOnly && "cursor-not-allowed",
        className
      )} 
      {...rest} 
    />
  )
}